module.exports = __webpack_public_path__ + "img/flag_emoji.b68757c5.png";